import React, {Component} from 'react';
import PropTypes from 'prop-types';
import OfferCardNew from "./offerCard/OfferCardNew";
import {
    ALL_OFFERS,
    SMARTLINK_OFFERS_KIT_CHANGING_CONTENT,
} from "../../../utils/constants";
import Spinner from "../../common/Spinner";
import NoContentMessage from "../../common/NoContentMessage";
import PartnerOfferFilters from "./filters/offers/PartnerOfferFilters";
import PageContent from "../../common/page/PageContent";
import OffersContactsModal from "./modal/OffersContactsModal";
import {isAdminAsPartner, isPartner} from "../../../utils/authUtils";
import ManagerOfferFilters from "./filters/offers/ManagerOfferFilters";
import SelectedOffersPopup from "./SelectedOffersPopup";
import ContentHeaderBtnsBlock from "../../navigation/header/ContentHeaderBtnsBlock";
import ToggleFiltersButton from "../../common/buttons/ToggleFiltersButton";
import IpRangesButton from "../../common/buttons/IpRangesButton";
import {needToLoadElements} from "../../../utils/scrollUtils";


export default class OffersCardsGridContent extends Component {
    static propTypes = {
        tabs: PropTypes.object,
        selectedNavTab: PropTypes.string,
        selectNavTab: PropTypes.func,
        selectedOfferIds: PropTypes.array,
        selectedOffers: PropTypes.array,
        onSelectOfferCard: PropTypes.func,
        displayedComponent: PropTypes.oneOf([ALL_OFFERS, SMARTLINK_OFFERS_KIT_CHANGING_CONTENT]),
        searchInputValue: PropTypes.string,
        beforeSearchInputAmount: PropTypes.any,
        filteredOffers: PropTypes.array,
        filters: PropTypes.object,
        resetAllFilters: PropTypes.func,
        toggleCheckboxFilter: PropTypes.func,
        onSelectFilterValue: PropTypes.func,
        onChangeSearchInput: PropTypes.func,
        filterOffers: PropTypes.func,
        needToFilter: PropTypes.bool,
        isContactsModalOpened: PropTypes.bool,
        isGrayCards: PropTypes.bool,
        displayIpRangesBtn: PropTypes.bool,
        closeContactsModal: PropTypes.func,
        onClickAdditionalEl: PropTypes.func,
        searchInputAmount: PropTypes.any,
        popupImg: PropTypes.any,
    };

    static defaultProps = {
        selectedOfferIds: []
    };

    state = {
        offersForRendering: [],
        componentMounted: false,
        offersInRow: 6,
        drawableOffers: 50,
        timeout: 0,
    };


    componentDidMount() {
        this.checkOffersInRow();
        window.addEventListener('click', this.checkOffersInRow);
        window.addEventListener('resize', this.checkOffersInRow);
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        const allOffers = this.props.allOffers;
        if ((allOffers && allOffers.length > 0 && this.props.needToFilter)
            || (this.props.searchInputValue !== prevProps.searchInputValue)) {
            this.filterOffers();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.checkOffersInRow);
        window.removeEventListener('resize', this.checkOffersInRow);
    }

    checkOffersInRow = () => {
        if (this.state.timeout) {
            clearTimeout(this.state.timeout);
        }
        this.setState({
            timeout: setTimeout(() => {
                const offerListWidth = document.getElementById("scrollable")?.offsetWidth | 0;
                const offersInRow = (offerListWidth / 260)|0;
                this.setState({
                    offersInRow: offersInRow,
                    drawableOffers: offersInRow * 8,
                    componentMounted: true
                });
            }, 500)
        })

    };

    handleScroll = (target) => {

        if (!needToLoadElements(target, 300)) {
            return;
        }

        const { offersForRendering, drawableOffers } = this.state;
        const { filteredOffers } = this.props;

        let endIdx = offersForRendering.length + drawableOffers;
        if (endIdx > filteredOffers.length) endIdx = filteredOffers.length;

        if (endIdx === offersForRendering.length) return;

        this.setState({
            offersForRendering: filteredOffers.slice(0, endIdx),
        });
    };

    filterOffers = () => {
        const filteredOffers = this.props.filterOffers(this.props.filters.isOnlySelectedOffers ? this.props.selectedOffers : this.props.allOffers);
        this.setState({
            offersForRendering: filteredOffers && filteredOffers.length >= this.state.drawableOffers
                ? filteredOffers.slice(0, this.state.drawableOffers)
                : filteredOffers,
        });
    };

    renderFiltersContent = (filterProps) => {
        const isPartnerPage = isPartner() || isAdminAsPartner();
        return isPartnerPage
            ? <PartnerOfferFilters
                {...filterProps}
                key={"1"}
                offers={this.props.isOnlySelectedOffers ? this.state.selectedOffers : this.props.allOffers}
                displayedComponent={this.props.displayedComponent}
                filters={this.props.filters}
                resetAllFilters={this.props.resetAllFilters}
                toggleCheckboxFilter={this.props.toggleCheckboxFilter}
                onSelectFilterValue={this.props.onSelectFilterValue}
            />
            : <ManagerOfferFilters
                {...filterProps}
                offers={this.props.isOnlySelectedOffers ? this.state.selectedOffers : this.props.allOffers}
                toggleCheckboxFilter={this.props.toggleCheckboxFilter}
                onSelectFilterValue={this.props.onSelectFilterValue}
                filters={this.props.filters}
                resetAllFilters={this.props.resetAllFilters}
            />
    };

    renderContentHeaderButtons = () => {
        return <ContentHeaderBtnsBlock>
            <IpRangesButton/>
            <ToggleFiltersButton/>
        </ContentHeaderBtnsBlock>
    }


    render() {
        const offerListWidth = document.getElementById("scrollable")?.offsetWidth | 0;
        const amount = this.state.offersInRow;
        const maxWidth = amount > 1
            ? (((offerListWidth - 10)/amount) - 5) + "px"
            : "100%";
        const width = "250px";
                return (
                        <PageContent
                                    tabs = {this.props.tabs}
                                    selectedTabName = {this.props.selectedNavTab}
                                    onSelectTab = {this.props.selectNavTab}
                                    onScroll = {this.handleScroll}
                                    displaySearchInput
                                    onChangeSearchInput = {this.props.onChangeSearchInput}
                                    searchInputAmount = {this.props.searchInputAmount}
                                    searchInputValue = {this.props.searchInputValue}
                                    beforeSearchInputAmount={this.props.beforeSearchInputAmount}
                                    displayContentHeader
                                    renderFilters = {this.renderFiltersContent}
                                    contentHeaderButtons={this.renderContentHeaderButtons()}
                                    contentEl = {
                                                    <div className="custom-tab" id="offersCards">
                                                        {
                                                            this.props.isLoading
                                                                ?
                                                                <Spinner/>
                                                                :
                                                                <>
                                                                    {
                                                                        this.state.offersForRendering && this.state.offersForRendering.length > 0
                                                                            ?
                                                                            <section id="offers-list">
                                                                                {this.state.offersForRendering.map((offer) =>
                                                                                    <OfferCardNew key={offer.offerId} offer={offer} offerIncomes={offer.offerIncomes}
                                                                                               isChecked={this.props.selectedOfferIds.includes(offer.offerId)}
                                                                                               onSelect={this.props.onSelectOfferCard}
                                                                                               isGray={this.props.isGrayCards} maxWidth={maxWidth}
                                                                                               width={width}/>)
                                                                                }
                                                                            </section>
                                                                            : <NoContentMessage/>
                                                                    }
                                                                </>
                                                        }
                                                    </div>
                                                    }
                                    additionalEl={<SelectedOffersPopup amount={this.props.selectedOfferIds && this.props.selectedOfferIds.length}
                                                                       onClick={this.props.onClickAdditionalEl}
                                                                       img={this.props.popupImg}
                                                                       toggleOnlySelected={() => this.props.toggleCheckboxFilter("isOnlySelectedOffers")}
                                    />}
                        >
                        <OffersContactsModal isOpen = {this.props.isContactsModalOpened} onCloseModal = {this.props.closeContactsModal}/>
                        </PageContent>
                         )
            }

}
